import React, { ReactElement } from 'react'
import { SelectOptionValues } from '../../../../React/Common/Components/Selects/Types'
import { SelectMultiProps } from '../../../../React/Common/Components/Selects'
import SelectMulti from '../../../../React/Common/Components/Selects/SelectMulti'

/**
 * <p>Outlined variant of {@link SelectMulti}, aligned with {@link OutlinedSelect}: merged wrapper class and shared
 * dropdown popper styling.</p>
 *
 * @param props - Same props as {@link SelectMulti}; {@code className} is merged with {@code outlined-multi-select}.
 * @returns Multi-select control with outlined styling.
 */
export const OutlinedSelectMulti = <T extends SelectOptionValues>(props: SelectMultiProps<T>): ReactElement => {
    const { className, popoverClassName, ...rest }: SelectMultiProps<T> = props

    const mergedClassName: string = [className, 'outlined-multi-select'].filter(Boolean).join(' ').trim()

    return (
        <SelectMulti
            {...rest}
            className={mergedClassName}
            variant='outlined'
            popoverClassName={popoverClassName ?? 'outlined-select-popper'}
        />
    )
}
